<template>
  <div :style="disabled?{cursor:'not-allowed',display:'inline-block'}:{}">
      <label class="toggle" :style="[disabled?{pointerEvents:'none',opacity:'.5'}:{}, isMini?{Height: '15px !important',Width: '30px !important'}:{}]">
          <input @change="toggleInput()" v-if="canChange && !isAdsManager" type="checkbox" v-model="inputValue">
          <input v-if="canChange && isAdsManager" type="checkbox" :value="inputValue" :checked="inputValue">
          <span :class="[isMini ? 'slider-mini round' : 'slider round',inputValue?'active':'']" :style="inputValue ? {backgroundColor:color} : {backgroundColor: '#9FB3CA'}" ></span>
      </label>
    </div>
</template>

<script>



export default {
  name: 's-toggle',
  data(){
    return {
      inputValue : false
    }
  },
  props: {
    isAdsManager: {
      type:Boolean,
      default:false
    },
    value: {
      type:Boolean,
      default:false
    },
    canChange:{
      type:Boolean,
      default:true
    },
    disabled:{
      type:Boolean,
      default:false
    },
    isMini:{
      type:Boolean,
      default:false
    },
    color:{
      type: String,
      default: "#2ecc71"
    }
  },

  watch:{
    inputValue(){
      this.$emit("input",this.inputValue)
    },
    value:{
      deep:true,
      handler(){
        this.inputValue = this.value
      }
    }
  },
  methods:{
    toggleInput(){
      // console.log("wowoooooooowwww",this.inputValue)
      this.$emit("change",this.inputValue)
    },
  },
  mounted(){
    this.inputValue = this.value
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
